// extracted by mini-css-extract-plugin
export default {"container":"EditCabinModal_container__8l788","form":"EditCabinModal_form__1NjGn","inputs":"EditCabinModal_inputs__+AJUW","input":"EditCabinModal_input__Wnaa7"};